export default function(el) {
    var $el = $(el);
    var $el_list = $('.p-select-list');


    $el.on('click','.p-select-list__main',function (e) {
        e.stopImmediatePropagation();
        select_slide();
    });

    $el.on('click', '.p-select-list__item', function () {
        $('.p-select-list__main').html(this.innerHTML);
        select_slide();
    });

    var select_slide = function () {
        if($(this).parents('.p-select').hasClass('p-select--disabled')) return;
        if($('.p-select-list__item').length < 1) {
            return false;
        }
        if($el.hasClass('p-select--on')){
            $el_list.stop().slideUp();
            $el.removeClass('p-select--on');
            $el.addClass('p-select--off');
        } else if($el.hasClass('p-select--off')){
            $el_list.stop().slideDown();
            $el.removeClass('p-select--off');
            $el.addClass('p-select--on');
        }
    };
};


// WEBPACK FOOTER //
// ./src/js/select.js